<template lang="pug">
.mt-2
  span.list_field(v-for="field in allowedKeys" v-if="fieldAvailable(field)")
    span.label
      b
        | {{ field | capitalize }}
    span.colon
      | : 
    span.value
      | {{ fieldData(field) }} 
</template>

<script>
import filters from 'common/filters.js'

export default {
  name: 'documents-resumen-auto-fields-vue',
  props: {
    resumen: { type: Object, default: () => { return {} } },
  },
  data() {
    return {
      allowedKeys: ['temas', 'procesal', 'responsabilidad']
    }
  },
  filters: {
    capitalize: filters.capitalize,
  },
  methods: {
    fieldAvailable(field) {
      return this.resumen[field] != undefined && this.resumen[field].length > 0
    },
    fieldData(field) {
      return this.resumen[field].join(', ')
    }
  }
}
</script>
